import { twMerge } from 'tailwind-merge';

interface ValidationTagProps {
  text: string;
  className?: string;
}

export const ValidationTag = ({ text, className }: ValidationTagProps) => {
  return (
    <div
      className={twMerge(
        'pt-2.25 pb-2 px-4.5 border border-primary rounded-full text-xs font-normal text-primary select-none [-webkit-touch-callout:none] [-webkit-user-select:none]',
        className,
      )}
    >
      {text}
    </div>
  );
};
